/* eslint-disable max-len */
import React, {
  useMemo, useContext, useState, useEffect,
} from 'react';
import { Button, Card } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { LocalizationContext } from '../../../Common/Localization/LocalizationProvider';
import { SMCUsersData } from '../Utils/TypeSmc';
import '../Style/StyleSmc.scss';
import { getSmcUserListStart, unlinkSmcUser } from '../Redux/sliceAddSmc';
import { RootState } from '../../../redux/rootState';
import AddUsers from './AddUsers';
import DataTable from '../../../Common/DataTable';
import { setLoader } from '../../../redux/loaderSlice';
import UnlinkComponentModal from '../../../Common/UnlinkComponentModal/UnlinkComponentModal';
import { defaultPageSize } from '../../../utils/Constant';

export default function ComponentUsers() {
  const { translations } = useContext(LocalizationContext);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(defaultPageSize);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortCol, setSortCol] = useState('');
  const [sortDir, setSortDir] = useState('asc');
  const [showModal, setShowModal] = useState(false);
  const [selectedSmcUserId, setSelectedSmcUserId] = useState('');

  const dispatch = useDispatch();
  const { smcUsersList, isLoading, totalSmcUsers } = useSelector((state: RootState) => state.addSmcDetailsReducer);
  const [open, setOpen] = useState(false);
  const { smcId } = useSelector((state: RootState) => state.addSmcDetailsReducer);

  const handleData = () => {
    const params = {
      page,
      rowsPerPage,
      searchQuery,
      SmcId: smcId,
      sortCol,
      sortDir,
    };
    if (params.SmcId) {
      dispatch(getSmcUserListStart(params));
    }
  };

  useEffect(() => {
    handleData();
  }, [page, rowsPerPage, searchQuery, sortCol, sortDir]);

  const handleLinkOff = (id: string) => {
    setSelectedSmcUserId(id);
    setShowModal(true);
  };
  const handelModal = () => {
    const paramData = {
      SmcId: smcId,
      SmcUserId: selectedSmcUserId,
      page,
      rowsPerPage,
      searchQuery,
      sortCol,
      sortDir,
    };
    dispatch(unlinkSmcUser(paramData));
    setShowModal(false);
  };

  const columns = useMemo(
    () => [
      // { key: 'sn', label: translations.sn },
      { key: 'action', label: translations.action },
      { key: 'FirstName', label: translations.name },
      { key: 'email', label: translations.emailId },
    ],
    [],
  );

  const data: SMCUsersData[] = smcUsersList.map((item, index) => {
    const transformedDataItem = {
      sn: index,
      action: 'linkOff',
      FirstName: `${item?.FirstName} ${item?.LastName}`,
      email: item?.Email,
      id: item?.UserId,
      smcUserId: item?.UserId,
    };
    return transformedDataItem;
  });

  const handleModal = () => {
    setOpen(!open);
  };
  const handleOnChange = () => {
    setOpen(false);
  };

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  return (
    <Card>
      <div className="separate_section">
        <div className="customerInfo_container">
          <div className="customerInfo">
            {translations.users}
          </div>
          <div>
            <Button className="button_save_and_next" onClick={handleModal}>{translations.addUsers}</Button>
          </div>
        </div>
        <DataTable<SMCUsersData>
          data={data}
          columns={columns}
          totalRecords={totalSmcUsers}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          searchQuery={searchQuery}
          setSearchQuery={(e) => { setSearchQuery(e); setPage(1); }}
          sortCol={sortCol}
          setSortCol={(e) => { setSortCol(e); setPage(1); }}
          sortDir={sortDir}
          setSortDir={(e) => { setSortDir(e); setPage(1); }}
          handleData={handleData}
          handleLinkOff={handleLinkOff}
          handleDataFromComponent
        />

        <UnlinkComponentModal
          show={showModal}
          setOpenFrom={() => setShowModal(false)}
          handleUnlink={handelModal}
        />
      </div>
      {open && <AddUsers show={open} setOpenFrom={handleModal} handleChange={handleOnChange} page={page} rowsPerPage={rowsPerPage} searchQuery={searchQuery} sortCol={sortCol} sortDir={sortDir} />}
    </Card>
  );
}
